import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  FormControl,
  Grid,
  IconButton, InputAdornment,
  Link,
  Slide,
  Stack,
  SvgIcon,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Popover,
  FormGroup,
  Checkbox,
  Drawer,
  useMediaQuery
} from '@mui/material';
import JobsMarketsFullDetails from './JobsMarketsFullDetails';
import { useSnackbar } from 'components/snackbar';
import { getJobList, setHideJob } from 'api/job';
import { useAuth } from 'hooks/useAuthContext';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { getJobPreferanceDetails } from 'api/users';
import { getTimeDifferenceString, changeNameFormat, formatNumber, toTitleCase } from 'utils/Utils';
import { SplashScreen } from 'components/loading-screen';
import { setApplication, saveJobApplication } from 'api/application';
import EmptyState from './EmptyState';
import { debounce } from 'lodash';
import { cleanData, clusteredData } from 'data/city.js';
import { SuitableChip, ModerateChip, NotSuitableChip } from '../icon/icon';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import JobsMarketsFullDetailsMobile from './JobsMarketsFullDetailsMobile';
import JobTypeToggle from './JobTypeToggle';
import JobTypeFilter from './JobTypeFilter';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useBackNavigationDialog } from 'hooks/useBackNavigationDialog';

const ALL_JOB_TYPES = ['Full time', 'Part time', 'Temporary', 'Internship'];
const PART_TIME_TYPES = ['Part time', 'Temporary', 'Internship'];
/**
 * A component that renders a tab panel for a tabbed interface.
 * It displays its children content only when the current tab index matches the panel's index.
 *
 * @param {object} props - The properties passed to the component.
 * @param {*} props.children - The content to be displayed inside the tab panel.
 * @param {number} props.value - The current active tab index.
 * @param {number} props.index - The index of this tab panel.
 * @param {object} [props.other] - Any other props to apply to the component.
 */
function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

/**
 * Generates accessibility properties for a tab component.
 *
 * @param {number} index - The index of the tab.
 * @returns {object} An object containing the id and aria-controls attributes
 * for the tab and its associated tab panel.
 */
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
};

const JobsMarket = ({ jobData, changeTabForDownload, showExternalStatus }) => {

  const { enqueueSnackbar } = useSnackbar();
  const { jobApply, setJobApply } = useAuth();

  const [jobs, setJobs] = useState(jobApply?.job ? [jobApply?.job] : []);
  const [data, setData] = useState(jobData || jobApply?.job || null);
  const [newJobData, setNewJobData] = useState(jobData || jobApply?.job);
  const [setActiveId, setSetActiveId] = useState(jobData?._id || jobApply?.job?._id || null);
  const [loading, setLoading] = useState(true);
  const [savedJob, setSavedJob] = useState('');
  const [unsaveJob, setUnsaveJob] = useState('');
  const [isJobPresent, setIsJobPresent] = useState(false);
  const [upperLimit, setUpperLimit] = useState(5);
  const [lowerLimit, setLowerLimit] = useState(0);
  const [fetchingMore, setFetchingMore] = useState(false);
  const [hasMoreJobs, setHasMoreJobs] = useState(true);
  const [totalJobCount, setTotalJobCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [showExternalJobStatus, setShowExternalJobStatus] = useState(showExternalStatus || '');
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterCriteria, setFilterCriteria] = useState({
    location: [],
    work_format: [],
    job_type: []
  });
  const [tempFilterCriteria, setTempFilterCriteria] = useState({
    location: [],
    work_format: [],
    job_type: []
  });

  const [sortCriteria, setSortCriteria] = useState(null);
  const [sortValue, setSortValue] = useState(null);

  const [jobTypes, setJobTypes] = useState([]);
  const [preferedLocation, setPreferedLocation] = useState([]);

  const containerRef = React.useRef(null);
  const [showSearch, setShowSearch] = React.useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [hidingJob, setHidingJob] = useState('');

  const inputRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const cardRefs = useRef({});

  // const [openDetailsDrawer, setOpenDetailsDrawer] = useState(!!jobData);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const open = Boolean(anchorEl);

  const [value, setValue] = useState(0);
  const recommendedChip = (score) => score >= 3 ? <SuitableChip /> : score >= 2 ? <ModerateChip /> : <NotSuitableChip />;

  const { openDialog, closeDialog, dialogLocation } = useBackNavigationDialog();
  const dialogIds = dialogLocation.state?.dialogIds || [];

  const openDetailsDrawer = dialogIds.includes("openJobMarketDetailsDrawer");
  const openFilter = dialogIds.includes("jobMarketFilter");

  useEffect(() => {
    if (setActiveId && cardRefs.current[setActiveId]) {
      scrollContainerRef.current.scrollTo({
        top: cardRefs.current[setActiveId].offsetTop - scrollContainerRef.current.clientHeight / 2 + cardRefs.current[setActiveId].offsetHeight / 2,
        behavior: 'smooth',
      });
    }
  }, [setActiveId]);

  useEffect(() => {
    if (!!jobData && isMobile) handleOpenDetailsDrawer();
    const fetchData = async () => {
      const preferredJobTypes = await fetchJobPreferences();
      const initialFilters = {
        ...filterCriteria,
        job_type: preferredJobTypes,
      };

      await fetchJobs(0, 5, null, '', '', initialFilters);
    };
    fetchData();
  }, []);
  // useEffect(() => {
  //   if (isMobile) {
  //     if (openDetailsDrawer) localStorage.setItem('tab', '2');
  //     else localStorage.removeItem('tab');
  //   }
  // }, [openDetailsDrawer]);

  const handleOpenDetailsDrawer = () => openDialog('openJobMarketDetailsDrawer');
  const handleCloseDetailsDrawer = () => {
    const timer = setTimeout(() => {
      closeDialog('openJobMarketDetailsDrawer');
    }, 300);
  }

  const handleShowSearch = () => {
    setShowSearch(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 300);
  };

  const handleShowHide = () => {
    setShowSearch(false);
    handleCloseSearchJob();
  }

  const handlePopoverOpen = (event) => {
    setTempFilterCriteria(filterCriteria);
    setAnchorEl(event.currentTarget);
    openDialog('jobMarketFilter');
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    closeDialog('jobMarketFilter');
  };

  const handleClearFilter = () => {
    setFilterLoading(true);
    setFilterApplied(false);

    setSortCriteria(null);
    setSortValue(null);

    const defaultJobTypes =
      jobTypes === 'both'
        ? [...ALL_JOB_TYPES]
        : jobTypes === 'Full time'
          ? ['Full time']
          : [...PART_TIME_TYPES];

    const clearedFilters = {
      location: [],
      work_format: [],
      job_type: defaultJobTypes,
    };

    setFilterCriteria(clearedFilters);
    setTempFilterCriteria(clearedFilters);

    fetchJobs(0, 5, null, searchValue, '', clearedFilters, true);

    handlePopoverClose();
  };

  const getToggleAlignment = () => {
    const selected = new Set(filterCriteria.job_type);

    if (selected.size >= ALL_JOB_TYPES.length) return 'both';
    if (selected.size === 1 && selected.has('Full time')) return 'Full time';
    if (selected.size > 0 && [...selected].every(type => PART_TIME_TYPES.includes(type))) {
      return 'Part time';
    }

    return 'both';
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchJobs = async (lower, upper, from = null, search = '', flag, filters = {}, reload = false) => {
    try {
      setLoading(true);
      const response = await getJobList({ lower, upper, search, filters, sort: sortCriteria });
      if (response?.success && response?.data) {
        const jobs = response.data?.jobs ? response.data?.jobs : [];
        setTotalJobCount(response.data?.totalJobCount);
        setHasMoreJobs(jobs.length === 5);
        setIsJobPresent(response.data?.isJobPresent);

        const updateJobs = (prevJobs, newJobs) => {
          const combinedJobs = [...prevJobs, ...newJobs];
          return Array.from(new Map(combinedJobs.map((job) => [job._id, job])).values());
        };

        const shouldUpdate = from === 'scroll' || (jobApply?.job && !reload);

        setJobs(prev => {
          let updatedJobs = shouldUpdate ? updateJobs(prev, jobs) : jobs;

          if (newJobData) {
            updatedJobs = [newJobData, ...updatedJobs];
            updatedJobs = Array.from(new Map(updatedJobs.map((job) => [job._id, job])).values());
          }

          return updatedJobs;
        });

        const shouldSetActive = flag || (!newJobData && jobs.length > 0);
        if (shouldSetActive && from !== 'scroll' && jobs.length > 0) {
          setData(jobs[0]);
          setSetActiveId(jobs[0]._id);
        }

        // if (isMobile) {
        //   let jobData = JSON.parse(localStorage.getItem('job'));
        //   if (jobData) {
        //     setData(jobData);
        //     setSetActiveId(jobData._id);
        //     // setOpenDetailsDrawer(true);
        //     handleOpenDetailsDrawer();
        //     setJobs((prevJobs) => {
        //       const updatedJobs = [jobData, ...prevJobs];
        //       const uniqueJobs = Array.from(
        //         new Map(updatedJobs.map(job => [job._id, job])).values()
        //       );
        //       return uniqueJobs;
        //     });
        //   }
        // }

        setNewJobData("");
      } else {
        console.error('Failed to fetch jobs:', response?.message);
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false);
      setFilterLoading(false);
      setFetchingMore(false);
    }
  };

  const fetchJobPreferences = async () => {
    try {
      setLoading(true);
      const response = await getJobPreferanceDetails();
      if (response?.success && response.data) {
        const { expected_ctc, fixed_ctc, variable_ctc, other_ctc, total_ctc } = response.data;
        const userJobPreference = response.data?.job_type[0] || 'both';
        setJobTypes(response?.data?.job_type[0] || []);
        const defaultJobTypes =
          userJobPreference === 'both'
            ? [...ALL_JOB_TYPES]
            : userJobPreference === 'Full time'
              ? ['Full time']
              : [...PART_TIME_TYPES];
        setFilterCriteria(prev => ({
          ...prev,
          job_type: defaultJobTypes,
        }));
        setTempFilterCriteria(prev => ({
          ...prev,
          job_type: defaultJobTypes,
        }));
        const location = response.data?.prefered_location?.filter((loc) => loc !== "Any");
        setPreferedLocation(location || []);
        setJobApply(prev => ({
          ...prev,
          totalExpectedCompensation: expected_ctc,
          totalCurrentCTC: total_ctc,
          currentFixed: fixed_ctc,
          currentVariable: variable_ctc,
          currentPerks: other_ctc
        }));
        return defaultJobTypes;
      } else {
        console.error('Failed to fetch job preferences', response?.message);
      }
    } catch (error) {
      console.error('Error fetching job preferences:', error);
    } finally {
      setLoading(false);
    }
    return [];
  };

  const handleJobData = (job) => {
    setJobApply(null);
    setData(job);
    setShowExternalJobStatus('');
  };

  const handleOpenDrawer = (newOpen, job) => () => {
    // setOpenDetailsDrawer(newOpen);
    newOpen ? handleOpenDetailsDrawer() : handleCloseDetailsDrawer();
    setJobApply(null);
    setData(job);
    setShowExternalJobStatus('');
  };

  const handleRemoveJob = async () => {
    setJobApply(null);
    setShowExternalJobStatus('');
    const flag = 'applied';
    setLowerLimit(0);
    setUpperLimit(5);
    // fetchJobs(0, 5, null, '', flag, {}, true);
    await fetchJobs(0, 5, null, searchValue, flag, filterCriteria, true);
    // setOpenDetailsDrawer(false);
    handleCloseDetailsDrawer();
  };

  const handleHideJob = async (job) => {
    if (!job || !job._id) {
      enqueueSnackbar('Invalid job data.', { variant: 'error' });
      return;
    }
    const jobId = job?._id;
    setHidingJob(jobId);
    try {
      const response = await setHideJob({ jobId });

      if (response && response?.success && response?.data) {
        enqueueSnackbar('Job successfully hidden.', { variant: 'success' });
        setLowerLimit(0);
        setUpperLimit(5);
        fetchJobs(0, 5, null, '', '', {}, true);
      } else {
        enqueueSnackbar('Failed to remove job. Please try again.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error hiding job:', error);
      enqueueSnackbar('An error occurred while hiding the job. Please try again.', { variant: 'error' });
    } finally {
      setHidingJob('');
    }
  };

  const handleSaveOrUnsaveJob = (jobId, actionType) => {
    if (actionType === 'saveJob') {
      setSavedJob(jobId);
    } else if (actionType === 'unsaveJob') {
      setUnsaveJob(jobId);
    }
    setShowExternalJobStatus('');
  };

  const handleChangeSaveOrUnsaveButton = async (actionType) => {
    if (actionType === 'saveJob') {
      setSavedJob('');
    } else if (actionType === 'unsaveJob') {
      setUnsaveJob('');
    }
  };

  const handleCardSaveOrUnsaveJob = async (job, actionType) => {
    if (actionType === 'saveJob') {
      setSavedJob(job?._id);
      const response = await saveJobApplication({ jobId: job?._id, companyId: job?.company_id, type: 'saved' });
      if (response?.success && response?.data != null) {
        job.application_saved = response?.data?.status === 'saved';
        setSavedJob('');
        enqueueSnackbar(response?.message, { variant: 'success' });
      } else {
        enqueueSnackbar(response?.message, { variant: 'error' });
      }
    } else if (actionType === 'unsaveJob') {
      setUnsaveJob(job?._id);
      const response = await saveJobApplication({ jobId: job?._id, companyId: job?.company_id, type: 'unsaved' });
      if (response?.success) {
        job.application_saved = false
        setUnsaveJob('');
        enqueueSnackbar(response?.message, { variant: 'success' });
      }
    }
  }

  const handleDoubleClick = (event) => {
    const { name, value } = event.target;

    if (value === '1' || value === '0') {
      setSortCriteria({
        salary: value,
      });
    } else {
      setSortCriteria({
        updatedAt: value === '11' ? '1' : '0'
      })
    }
  };

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const { scrollTop, clientHeight, scrollHeight } = container;
    const scrollPosition = scrollTop + clientHeight;

    const threshold = 50;

    if (scrollHeight - scrollPosition <= threshold && !fetchingMore && hasMoreJobs) {
      setFetchingMore(true);
      setLowerLimit((prev) => prev + 5);
      setUpperLimit((prev) => prev + 5);
      fetchJobs(lowerLimit + 5, upperLimit + 5, 'scroll', searchValue, '', filterCriteria);
    }
  };

  const handleCloseSearchJob = () => {
    if (searchValue) {
      setLowerLimit(0);
      setUpperLimit(5);
      setSearchValue('');
      setFilterLoading(true);
      fetchJobs(0, 5, null, '', '', filterCriteria, true);
    }
  };
  const debouncedSearch = useCallback(
    debounce(async (value) => {
      setFilterLoading(true);
      setLowerLimit(0);
      setUpperLimit(5);
      await fetchJobs(0, 5, null, value, '', filterCriteria, true);
    }, 500),
    []
  );
  const handleSearchInputChange = (value) => {
    setSearchValue(value);
    // debouncedSearch(value);
  };
  const handleDownloadResume = (jobInprogessData) => {
    changeTabForDownload(jobInprogessData, '2');
  };

  const handleApplyFilter = async () => {
    if (!sortCriteria && tempFilterCriteria?.location?.length === 0 && tempFilterCriteria?.work_format?.length === 0 && tempFilterCriteria?.job_type?.length === 0) {
      return;
    }
    setFilterCriteria(tempFilterCriteria);
    setFilterLoading(true);
    setFilterApplied(true);
    setLowerLimit(0);
    setUpperLimit(5);
    // setSearchValue('');
    fetchJobs(0, 5, 'apply', searchValue, '', tempFilterCriteria, true);
    handlePopoverClose();
  };

  const handleSortChange = (event) => {
    setLowerLimit(0);
    setUpperLimit(5);
    const { name, value } = event.target;

    setSortValue(value);

    if (value === '1' || value === '0') {
      setSortCriteria({
        salary: value,
      });
    } else {
      setSortCriteria({
        updatedAt: value === '11' ? '1' : '0'
      })
    }
  };

  const handleChangeFilterCriteria = (event, value) => {
    const { name } = event.target;
    setTempFilterCriteria((prevCriteria) => ({
      ...prevCriteria,
      [name]: prevCriteria[name].includes(value)
        ? prevCriteria[name]?.filter((item) => item !== value)
        : [...prevCriteria[name], value],
    }));
  };

  const handleJobPreferences = async () => {
    await fetchJobPreferences();
    setLowerLimit(0);
    setUpperLimit(5);
  };
  const handleUpdateTjScore = (TjScore) => {
    setJobs((prevJobs) =>
      prevJobs.map((job) =>
        job._id === data._id
          ? { ...job, tj_score: TjScore }
          : job
      )
    );
  };
  const handleFetchJobFromJobType = async (value) => {
    if (filterCriteria?.location?.length === 0 && filterCriteria?.work_format?.length === 0 && sortCriteria === null) setFilterApplied(false);
    setFilterLoading(true);
    setLowerLimit(0);
    setUpperLimit(5);
    const jobTypeFilter =
      value === 'both'
        ? [...ALL_JOB_TYPES]
        : value === 'Full time'
          ? ['Full time']
          : [...PART_TIME_TYPES];

    const updatedFilter = {
      ...filterCriteria,
      job_type: jobTypeFilter,
    };

    setFilterCriteria(updatedFilter);
    // setSearchValue('');
    await fetchJobs(0, 5, null, searchValue, '', updatedFilter, true);
  };

  if (loading && jobs.length === 0) {
    return (
      <Grid container justifyContent="center" sx={{ position: 'relative', overflow: 'hidden', width: '100%', height: 'calc(100vh - 10vh)' }} alignItems="center">
        <SplashScreen />
      </Grid>
    );
  };

  const isFilterOrSearchActive = filterApplied || !!showSearch;

  if (!isJobPresent && !isFilterOrSearchActive && !jobApply) {
    return (<EmptyState tab={'job-market'} />);
  }

  const showFilterControls = isJobPresent || isFilterOrSearchActive;
  const showEmptyListMessage = jobs.length === 0;

  const handleSearch = async (value) => {
    setFilterLoading(true);
    setLowerLimit(0);
    setUpperLimit(5);
    await fetchJobs(0, 5, null, value, '', filterCriteria, true);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: { xs: 'calc(100vh - 70px)', sm: 'calc(100vh - 70px)', md: 'calc(100vh - 110px)', lg: 'calc(100vh - 110px)' },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Box className="active-jobs-list">
            {/* header/filter */}
            {showFilterControls && (
              <Box className="header-wrapper" ref={containerRef}>
                <Box className="filter-wrapper" mb={2}>
                  <Typography className="head-title" variant="p" sx={{ display: { xs: 'block', md: 'none' } }}>Jobs Market</Typography>
                  <Stack direction="row" justifyContent={'space-between'} spacing={2}>
                    <Typography className="head-text" variant="p">
                      {totalJobCount > 0 ? `${totalJobCount} Active Jobs` : 'No Jobs Found'}
                    </Typography>
                    {/* filter */}
                    <Box>
                      <Stack direction="row" spacing={1}>
                        <IconButton
                          aria-label="update"
                          aria-owns={openFilter || filterApplied ? 'filter-by' : undefined}
                          aria-haspopup="true"
                          onClick={handlePopoverOpen}
                        >
                          {filterApplied && <SvgIcon className="ellipse-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                              <circle cx="6" cy="6.5" r="6" fill="#C12929" />
                            </svg>
                          </SvgIcon>}
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                            <path file-rule="evenodd" clipRule="evenodd" d="M7.0923 12.3074H16.3846C16.7243 12.3074 17 12.0317 17 11.692C17 11.3523 16.7243 11.0766 16.3846 11.0766H7.0923C6.80677 9.67293 5.56431 8.61508 4.07692 8.61508C2.37846 8.61508 1 9.99355 1 11.692C1 13.3905 2.37846 14.7689 4.07692 14.7689C5.56431 14.7689 6.80677 13.7111 7.0923 12.3074ZM4.07692 9.84585C5.096 9.84585 5.92308 10.6729 5.92308 11.692C5.92308 12.7111 5.096 13.5382 4.07692 13.5382C3.05785 13.5382 2.23077 12.7111 2.23077 11.692C2.23077 10.6729 3.05785 9.84585 4.07692 9.84585ZM10.9077 3.69201H1.61538C1.27569 3.69201 1 3.9677 1 4.30739C1 4.64708 1.27569 4.92278 1.61538 4.92278H10.9077C11.1932 6.32647 12.4357 7.38432 13.9231 7.38432C15.6215 7.38432 17 6.00585 17 4.30739C17 2.60893 15.6215 1.23047 13.9231 1.23047C12.4357 1.23047 11.1932 2.28832 10.9077 3.69201ZM13.9231 2.46124C14.9422 2.46124 15.7692 3.28832 15.7692 4.30739C15.7692 5.32647 14.9422 6.15355 13.9231 6.15355C12.904 6.15355 12.0769 5.32647 12.0769 4.30739C12.0769 3.28832 12.904 2.46124 13.9231 2.46124Z" fill="#9CA3AF" stroke="white" strokeWidth="0.5" />
                          </svg>
                        </IconButton>
                        <IconButton className={showSearch ? "search-active" : ""} aria-label="update" onClick={handleShowSearch}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              file-rule="evenodd"
                              clipRule="evenodd"
                              d="M1.23254 7.20043C1.23254 3.9044 3.9045 1.23242 7.20052 1.23242C10.4965 1.23242 13.1685 3.9044 13.1685 7.20043C13.1685 10.4964 10.4965 13.1684 7.20052 13.1684C3.90449 13.1684 1.23254 10.4964 1.23254 7.20043ZM7.20052 0.232422C3.35221 0.232422 0.232544 3.35212 0.232544 7.20043C0.232544 11.0487 3.35221 14.1684 7.20052 14.1684C8.94474 14.1684 10.5393 13.5275 11.7615 12.4684L14.9139 15.6208C15.1092 15.8161 15.4258 15.8161 15.621 15.6208C15.8163 15.4255 15.8163 15.1089 15.621 14.9137L12.4686 11.7613C13.5277 10.5391 14.1685 8.94459 14.1685 7.20043C14.1685 3.35212 11.0488 0.232422 7.20052 0.232422Z"
                              fill="#9CA3AF"
                            />
                          </svg>
                        </IconButton>
                      </Stack>
                    </Box>
                  </Stack>
                </Box>

                {showSearch &&
                  <Box className="search-wrapper">
                    <Stack direction="row" alignItems={'center'} spacing={2} sx={{ width: '100%' }}>
                      <TextField
                        id="searching"
                        value={searchValue}
                        inputRef={inputRef}
                        size="small"
                        variant="outlined"
                        placeholder="Enter designation / companies / location"
                        sx={{ background: '#ffffff', borderRadius: '12px', width: '100%' }}
                        onChange={(e) => handleSearchInputChange(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {filterLoading ? <CircularProgress size={20} /> :
                                <IconButton sx={{ border: 'none !important' }} edge="end" size="small" onClick={() => handleSearch(searchValue)}>
                                  <ArrowForwardIcon />
                                </IconButton>
                              }
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Link onClick={handleShowHide} sx={{ 'cursor': 'pointer' }} className='cancel-btn' underline="none">Cancel</Link>
                    </Stack>
                  </Box>
                  // </Slide>
                }
              </Box>
            )}
            {/* Jobs type toggle */}
            {jobTypes == "both" && <JobTypeToggle alignment={getToggleAlignment()} handleFetchJobFromJobType={handleFetchJobFromJobType} />}
            {!showEmptyListMessage &&
              <Box className="active-jobs-container" ref={scrollContainerRef} onScroll={handleScroll} sx={{ paddingBottom: '170px!important' }}>
                {jobs?.length > 0 && jobs?.map((job, index) => (
                  <Card
                    ref={(el) => (cardRefs.current[job?._id] = el)}
                    className={`job-card-view${(setActiveId && job._id === setActiveId) || (!setActiveId && index === 0) ? ' first-job-item' : ''}`}
                    variant="outlined"
                    sx={{ marginBottom: '12px' }}
                    key={index}
                    tabIndex={0}
                    onClick={() => {
                      isMobile ?
                        handleOpenDrawer(true, job)() :
                        handleJobData(job);
                      setSetActiveId(job._id);
                    }}
                  >
                    {/* card top */}
                    <Box className="job-card-view-top">
                      <Box>{recommendedChip(job.tj_score)}</Box>
                      <Box className="active-jobs-info">
                        {/* card content */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={7}>
                            <Stack direction="row" alignItems={'center'} justifyContent={'space-between'}>
                              <Typography className="post-title">{job?.title}</Typography>
                              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" >
                                  <path d="M7.45837 3.39961L12.8917 8.83294C13.5334 9.47461 13.5334 10.5246 12.8917 11.1663L7.45837 16.5996" stroke="#6B7280" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </Box>
                            </Stack>
                            {job?.is_company_name_confidential ? <Typography className="company-name">Company Name - Confidential</Typography> : <Typography className="company-name">{job?.company || ''}</Typography>}
                            <Box mt={0.5} className="work-type">
                              <Stack direction="row" flexWrap="wrap" alignItems={'center'} spacing={0.5}>
                                <Typography variant="p" className="city">{job?.location}</Typography>
                                {job?.job_type === 'Full time' && <>
                                  <Typography variant="body1">•</Typography>
                                  <Typography variant="p" className="city">{job?.job_type}</Typography></>}
                                <Typography variant="body1">•</Typography>
                                <Typography variant="p" className="city">{job?.work_mode}</Typography>
                              </Stack>
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={5}>

                            {(job?.is_compensation_confidential || !job?.salary) ?
                              <Box className="ctc-range">
                                <Typography className="text-1" >Not Disclosed</Typography>
                                <Typography className="text-2">Compensation</Typography>
                              </Box> :
                              <Box className="ctc-range">
                                <Typography className="text-1">₹{job?.job_type === 'Full time' ? formatNumber(job?.salary) : Intl.NumberFormat('en-IN').format(job?.salary)}</Typography>
                                <Typography className="text-2">{job?.job_type === 'Full time' ? job?.compensation : job?.compensation_model}</Typography>
                              </Box>
                            }
                          </Grid>
                        </Grid>
                        {/* card bottom */}
                        <Box sx={{ marginTop: { xs: '12px', md: '8px' } }}>
                          <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent={'space-between'} spacing={{ xs: 2, md: 0 }}>
                            <Typography variant="p" className="posted-date">
                              {job?.updatedAt ? getTimeDifferenceString(job?.updatedAt, "Posted") : 'NA'}
                            </Typography>
                            <Box className="save-hide-job">
                              <Stack direction="row" alignItems={'center'} justifyContent={{ xs: 'space-between' }} spacing={1}>
                                <Box>
                                  {/* unsaved / saved job */}
                                  {job?.application_saved ?
                                    <Button
                                      variant="text"
                                      size="small"
                                      className={unsaveJob === job?._id ? "save-job-btn" : "saved-btn"}
                                      disabled={unsaveJob === job?._id ? true : false}
                                      sx={{ width: '80px' }}
                                      onClick={(e) => {
                                        if (setActiveId && job?._id === setActiveId && !isMobile) {
                                          handleSaveOrUnsaveJob(job?._id, 'unsaveJob')
                                        } else {
                                          e.stopPropagation();
                                          handleCardSaveOrUnsaveJob(job, 'unsaveJob');
                                        }
                                      }}
                                      startIcon={
                                        <SvgIcon style={{ width: '12px', height: '12px' }}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="8"
                                            height="6"
                                            viewBox="0 0 8 6"
                                            fill="none"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M7.77869 1.3764L3.45821 5.69687C3.16468 5.99041 2.67851 5.99041 2.3758 5.69687L0.220152 3.54122C-0.0733838 3.24769 -0.0733838 2.76152 0.220152 2.45881C0.513687 2.16527 0.999855 2.16527 1.30256 2.45881L2.92618 4.08243L6.70545 0.303159C6.99898 0.00962395 7.48515 0.00962395 7.78786 0.303159C8.07222 0.596695 8.07222 1.08286 7.77869 1.3764Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </SvgIcon>
                                      }
                                    >
                                      {unsaveJob === job?._id ? 'Unsaving...' : 'Job saved'}
                                    </Button> :
                                    <Button
                                      className="save-job-btn"
                                      startIcon={<AddCircleIcon />}
                                      disabled={savedJob === job._id ? true : false}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCardSaveOrUnsaveJob(job, 'saveJob');
                                      }}
                                    >
                                      {savedJob === job._id ? 'Saving...' : 'Save Job'}
                                    </Button>
                                  }
                                </Box>
                                {/* hide/remove job */}
                                <Box>
                                  <Tooltip title={'This job will be permanently removed from your view'} arrow placement='top'>
                                    <Button
                                      disableRipple
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleHideJob(job);
                                      }}
                                      className={`hide-job-btn ${(job?.application_saved || hidingJob === job?._id) ? 'disabled' : ''}`}
                                      disabled={job?.application_saved}
                                      startIcon={
                                        <SvgIcon>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="16"
                                            viewBox="0 0 18 16"
                                            fill="none"
                                          >
                                            <path
                                              file-rule="evenodd"
                                              clipRule="evenodd"
                                              d="M12.3306 3.83292L15.8719 0L16.8888 1.10074L3.12329 16L2.1063 14.8993L4.39451 12.4226C2.50583 11.2629 1.053 9.71004 0.399235 8.92382C0.163146 8.64862 0.163146 8.21618 0.399235 7.94107C1.52517 6.5848 4.92116 2.9484 8.95275 2.9484C10.1151 2.9484 11.2591 3.30221 12.3306 3.83292ZM9.11208 7.18513C9.15257 7.18976 9.19091 7.19413 9.22519 7.19413L10.9686 5.30713C10.4055 4.89435 9.73363 4.63882 8.9891 4.63882C7.06408 4.63882 5.50229 6.32924 5.50229 8.4128C5.50229 9.21867 5.73837 9.94596 6.11974 10.5553L7.84501 8.688C7.82679 8.60933 7.82679 8.51102 7.82679 8.4128C7.82679 7.7248 8.33532 7.17449 8.97088 7.17449C9.01884 7.17449 9.0668 7.17996 9.11208 7.18513ZM14.8699 5.71415C16.1939 6.6132 17.253 7.60405 17.8014 8.15454C18.0662 8.42974 18.0662 8.83338 17.8014 9.12698C16.6099 10.393 13.0732 13.7142 8.91252 13.7142C8.21278 13.7142 7.5319 13.6224 6.88887 13.4573L8.28843 12.0995C8.49643 12.1361 8.70452 12.1545 8.91252 12.1545C10.9172 12.1545 12.5437 10.5766 12.5437 8.6316C12.5437 8.42974 12.5248 8.22796 12.487 8.02609L14.8699 5.71415Z"
                                              fill={job?.application_saved ? 'grey' : 'black'}
                                            />
                                          </svg>
                                        </SvgIcon>
                                      }
                                    >
                                      {hidingJob === job?._id ? 'Removing...' : 'Remove'}
                                    </Button>
                                  </Tooltip>
                                </Box>
                              </Stack>
                            </Box>
                          </Stack>
                        </Box>
                      </Box>
                    </Box>
                    {/* Part time band */}
                    {job?.job_type !== 'Full time' &&
                      <Box className="job-card-view-bottom">
                        <Box mt={0.5} className="work-type">
                          <Stack direction="row" flexWrap="wrap" alignItems={'center'} spacing={0.5}>
                            <Typography variant="p" className="city">{job?.job_type}</Typography>
                            <Typography variant="body1">•</Typography>
                            <Typography variant="p">{job?.weekly_time_commitment} hrs./week</Typography>
                            <Typography variant="body1">•</Typography>
                            <Typography variant="p">For {job?.total_time_commitment_requirement} weeks</Typography>
                          </Stack>
                        </Box>
                      </Box>}
                  </Card>
                ))}
                {/* more job fetching loading */}
                {fetchingMore &&
                  <Box display='flex' justifyContent='center' alignItems='center'>
                    <CircularProgress size="sm" sx={{ width: 15, height: 15, marginRight: '5px' }} />  Loading...
                  </Box>}
              </Box>
            }
          </Box>
        </Grid>
        {showEmptyListMessage ? (
          <EmptyState tab={'job-market'} isFiltered={isFilterOrSearchActive} />
        ) : (
          <Grid item xs={12} md={8} sx={{ display: { xs: 'none', md: 'block' } }}>
            {/* job full details */}
            {jobs?.length > 0 && data && (
              isMobile ?
                <Drawer
                  className="mob-side-panel"
                  open={openDetailsDrawer}
                  anchor={'right'}
                  onClose={handleOpenDrawer(false)}>
                  <JobsMarketsFullDetailsMobile
                    data={data}
                    onApplied={handleRemoveJob}
                    savedJob={savedJob}
                    unsaveJob={unsaveJob}
                    handleChangeSaveOrUnsaveButton={handleChangeSaveOrUnsaveButton}
                    handleSaveOrUnsaveJob={handleSaveOrUnsaveJob}
                    downloadResume={handleDownloadResume}
                    showExternalJobStatus={showExternalJobStatus}
                    onJobPreferencesChange={handleJobPreferences}
                    updateTJScore={handleUpdateTjScore}
                    onClose={handleOpenDrawer(false)}
                  />
                </Drawer> :
                <JobsMarketsFullDetails
                  data={data}
                  onApplied={handleRemoveJob}
                  savedJob={savedJob}
                  unsaveJob={unsaveJob}
                  handleChangeSaveOrUnsaveButton={handleChangeSaveOrUnsaveButton}
                  handleSaveOrUnsaveJob={handleSaveOrUnsaveJob}
                  downloadResume={handleDownloadResume}
                  showExternalJobStatus={showExternalJobStatus}
                  onJobPreferencesChange={handleJobPreferences}
                  updateTJScore={handleUpdateTjScore}
                />
            )}
          </Grid>
        )}
      </Grid>
      {/* filter */}
      {isMobile ?
        <Drawer
          anchor="bottom"
          open={openFilter}
          onClose={handlePopoverClose}
          className="mobile-bottomsheet-dialog filter-by-overlay"
        >
          <Box sx={{ height: 400, width: { xs: '100%', md: '600px' } }}>
            <Grid container sx={{ height: '100%' }}>
              <Grid item xs={4} md={5} className="filter-by-tabs-item">
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                  aria-label="Vertical tabs example"
                  sx={{ height: '100%' }}
                >
                  <Tab label="Sort By" disableRipple {...a11yProps(0)} />
                  <Tab label="Location" disableRipple {...a11yProps(1)} />
                  <Tab label="Job Suitability" disableRipple {...a11yProps(2)} />
                  <Tab label="Job Type" disableRipple {...a11yProps(3)} />
                </Tabs>
              </Grid>

              <Grid item xs={8} md={7} className="filter-by-tabs-content">
                <TabPanel value={value} index={0}>
                  <Box>
                    <Typography className="title">Sort By</Typography>
                  </Box>
                  <Box>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-1"
                        name="salary"
                        value={sortValue}
                        onChange={handleSortChange}
                      >
                        <FormControlLabel value="1" control={<Radio onDoubleClick={handleDoubleClick} />} label="Compensation (High to Low)" />
                        <FormControlLabel value="0" control={<Radio onDoubleClick={handleDoubleClick} />} label="Compensation (Low to High)" />
                        <FormControlLabel value="11" control={<Radio onDoubleClick={handleDoubleClick} />} label="Posted (Latest First)" />
                        <FormControlLabel value="00" control={<Radio onDoubleClick={handleDoubleClick} />} label="Posted (Oldest First)" />
                      </RadioGroup>
                    </FormControl>
                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', marginTop: '0.5rem', marginBottom: '0.5rem' }} />
                  </Box>
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Typography className="title">Location</Typography>
                  <FormControl>
                    <FormGroup>
                      <Box sx={{ maxHeight: '14rem', overflow: "auto", marginBottom: '16px' }}>
                        {[...preferedLocation]?.map((data, index) => (
                          <FormControlLabel
                            key={index}
                            control={
                              <Checkbox
                                checked={tempFilterCriteria?.location?.some((fl) => (clusteredData?.find(ct => ct?.value === fl)?.name === data || fl === data))}
                                onChange={(e) => handleChangeFilterCriteria(e, clusteredData?.find(ct => ct?.name === data)?.value || data)}
                                name="location"
                              />
                            }
                            label={data}
                          />
                        ))}
                      </Box>
                    </FormGroup>
                  </FormControl>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <Typography className="title">Job Suitability</Typography>
                  <FormControl>
                    <FormGroup>
                      {["Highly Suitable", "Moderately Suitable", "Not Suitable"].map((data, index) => (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              name="work_format"
                              checked={tempFilterCriteria?.work_format?.includes(data)}
                              onChange={(e) => handleChangeFilterCriteria(e, data)}
                              value={data}
                            />
                          }
                          label={data} />
                      ))}
                    </FormGroup>
                  </FormControl>
                </TabPanel>

                <TabPanel value={value} index={3}>
                  <FormControl>
                    <FormGroup sx={{ maxHeight: '100%' }} >
                      <Typography className="title">Job Type</Typography>
                      <Box sx={{ maxHeight: '14rem', overflow: "auto", marginBottom: '16px' }}>
                        <JobTypeFilter filterApplied={filterApplied} jobTypes={jobTypes} filterCriteria={tempFilterCriteria} setFilterCriteria={setTempFilterCriteria} handleChangeFilterCriteria={handleChangeFilterCriteria} />
                      </Box>
                    </FormGroup>
                  </FormControl>
                </TabPanel>

                <Box className="filter-by-actions-btn">
                  <Stack direction="row" spacing={2}>
                    <Button variant="outlined" fullWidth onClick={filterApplied ? handleClearFilter : handlePopoverClose}>{filterApplied ? "Clear Filter" : "Cancel"}</Button>
                    <Button variant="contained" fullWidth onClick={handleApplyFilter} disabled={filterLoading}>{filterLoading ? 'Applying...' : 'Apply'}</Button>
                  </Stack>
                </Box>

              </Grid>
            </Grid>
          </Box>

        </Drawer> :
        <Popover elevation={3}
          id="filter-by"
          className="filter-by-overlay"
          open={openFilter}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          sx={{
            top: '15px',
            left: '-150px'
          }}
          disableRestoreFocus
        >
          <Box
            sx={{
              position: "relative",
              "&::before": {
                backgroundColor: "white",
                content: '""',
                display: "block",
                position: "absolute",
                width: 12,
                height: 12,
                top: -8,
                transform: "rotate(45deg)",
                left: "calc(25% - 7px)",
                borderTop: '1px solid #D2D5DB',
                borderLeft: '1px solid #D2D5DB'
              }
            }}
          />
          <Box sx={{ height: 400, width: 600 }}>
            <Grid container sx={{ height: '100%' }}>
              <Grid item xs={5} className="filter-by-tabs-item">
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                  aria-label="Vertical tabs example"
                  sx={{ height: '100%' }}
                >
                  <Tab label="Sort By" disableRipple {...a11yProps(0)} />
                  <Tab label="Location" disableRipple {...a11yProps(1)} />
                  <Tab label="Job Suitability" disableRipple {...a11yProps(2)} />
                  <Tab label="Job Type" disableRipple {...a11yProps(3)} />
                </Tabs>
              </Grid>

              <Grid item xs={7} className="filter-by-tabs-content">
                <TabPanel value={value} index={0}>
                  <Box>
                    <Typography className="title">Sort By</Typography>
                  </Box>
                  <Box>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-1"
                        name="salary"
                        value={sortValue}
                        onChange={handleSortChange}
                      >
                        <FormControlLabel value="1" control={<Radio onDoubleClick={handleDoubleClick} />} label="Compensation (High to Low)" />
                        <FormControlLabel value="0" control={<Radio onDoubleClick={handleDoubleClick} />} label="Compensation (Low to High)" />
                        <FormControlLabel value="11" control={<Radio onDoubleClick={handleDoubleClick} />} label="Posted (Latest First)" />
                        <FormControlLabel value="00" control={<Radio onDoubleClick={handleDoubleClick} />} label="Posted (Oldest First)" />
                      </RadioGroup>
                    </FormControl>
                    <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', marginTop: '0.5rem', marginBottom: '0.5rem' }} />
                  </Box>
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Typography className="title">Location</Typography>
                  <FormControl>
                    <FormGroup>
                      <Box sx={{ maxHeight: '16rem', overflow: "auto", marginBottom: '16px' }}>
                        <Stack>
                          {[...preferedLocation]?.map((data, index) => (
                            <FormControlLabel
                              key={index}
                              control={
                                <Checkbox
                                  checked={tempFilterCriteria?.location?.some((fl) => (clusteredData?.find(ct => ct?.value === fl)?.name === data || fl === data))}
                                  onChange={(e) => handleChangeFilterCriteria(e, clusteredData?.find(ct => ct?.name === data)?.value || data)}
                                  name="location"
                                />
                              }
                              label={data}
                            />
                          ))}
                        </Stack>
                      </Box>
                    </FormGroup>
                  </FormControl>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <Typography className="title">Job Suitability</Typography>
                  <FormControl>
                    <FormGroup>
                      {["Highly Suitable", "Moderately Suitable", "Not Suitable"].map((data, index) => (
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              name="work_format"
                              checked={tempFilterCriteria?.work_format?.includes(data)}
                              onChange={(e) => handleChangeFilterCriteria(e, data)}
                              value={data}
                            />
                          }
                          label={data} />
                      ))}
                    </FormGroup>
                  </FormControl>
                </TabPanel>

                <TabPanel value={value} index={3}>
                  <FormControl>
                    <FormGroup>
                      <Typography className="title">Job Type</Typography>
                      <Box sx={{ maxHeight: '16rem', overflow: "auto", marginBottom: '16px' }}>
                        <JobTypeFilter filterApplied={filterApplied} jobTypes={jobTypes} filterCriteria={tempFilterCriteria} setFilterCriteria={setFilterCriteria} handleChangeFilterCriteria={handleChangeFilterCriteria} />
                      </Box>
                    </FormGroup>
                  </FormControl>
                </TabPanel>

                <Box className="filter-by-actions-btn">
                  <Stack direction="row" spacing={2}>
                    <Button variant="outlined" fullWidth onClick={filterApplied ? handleClearFilter : handlePopoverClose} >{filterApplied ? "Clear Filter" : "Cancel"}</Button>
                    <Button variant="contained" fullWidth onClick={handleApplyFilter} disabled={filterLoading}>{filterLoading ? 'Applying...' : 'Apply'}</Button>
                  </Stack>
                </Box>

              </Grid>
            </Grid>
          </Box>
        </Popover>
      }
      {/* blur screen  */}
      <Drawer open={filterLoading}>
        <div className="loading-overlay">
          <div className="loading-spinner">
            <CircularProgress />
          </div>
        </div>
      </Drawer>

    </Box >
  );
};

export default JobsMarket;
